import { useLocation } from 'react-router-dom';

export const useWindowLocation = () => {
  const routerLocation = useLocation();
  const windowLocation = window.location;

  return {
    pathname: routerLocation.pathname,
    search: routerLocation.search,
    hash: routerLocation.hash,
    hostname: windowLocation.hostname,
    origin: windowLocation.origin,
    protocol: windowLocation.protocol,
    port: windowLocation.port,
    href: windowLocation.href,
    replace: windowLocation.replace,
    reload: windowLocation.reload,
    assign: windowLocation.assign,
  };
};
